export { default as LifestylesGammasFilter } from './LifestylesGammasFilter';
